import { gql } from 'react-apollo';

/**
 * No not modify the ids, it will crash the cache
 * Add only uniq ID-ul by subject
 * */
export const resourceFieldsFragment = gql`
  fragment resourceFields on Resource {
    id: uid
    resourceId: id
    displayName
    description
    icon
    group

    ... on URLResource {
      isShareable
      fileSize
      url
      isGoogleClassroomShareable
      contentType
    }

    ... on SourceResource {
      isShareable
      fileSize
      url
      isGoogleClassroomShareable
      contentType
    }

    ... on LTIResource {
      isShareable
      url
    }

    ... on PartnerLinkResource {
      isShareable
      url
      emphasis
      altText
      subtitle
      isGoogleClassroomShareable
    }

    ... on DistanceLinkResource {
      isShareable
      url
      isGoogleClassroomShareable
    }

    ... on YoutubeResource {
      isShareable
      fileSize
      url
    }

    ... on EmbeddedVideoResource {
      isShareable
      fileSize
      url
      videoId
      thumbnailUrl
      visibilityToStudents
    }

    ... on TeacherModuleResource {
      coursePath
    }

    ... on AssessmentResource {
      assessmentId
      resourceTypeDetails
    }

    ... on StudentPracticeResource {
      assessmentId
    }

    ... on GroupResource {
      description
      url
    }

    ... on PracticeQuestionsResource {
      questions {
        index
        accNum
        title
        libraryId
        subjectId
        itemId
        hasAllTopicsCovered
        type
      }
    }
  }
`;
/**
 * No not modify the ids, it will crash the cache
 * Add only uniq ID-ul by subject
 * */
export const courseOutline = gql`
  query courseOutline(
    $subjectId: String
    $educationPeriod: String
    $filter: String
  ) {
    courseOutline(
      subjectId: $subjectId
      educationPeriod: $educationPeriod
      filter: $filter
    ) {
      id: subjectId
      earliestReportingEp
      educationPeriod
      ppcTagPair
      subunitLabel
      widgetTagColumn
      widgetTagColumnLabel
      title
      description
      searchResultsTags
      unitsLabel
      resources {
        ...resourceFields
      }

      units {
        unitId: id
        displayName
        title
        description
        number
        isShareable
        instructionalPeriods
        examWeighting
        filter
        resources {
          ...resourceFields
        }

        subunits {
          subunitId: id
          displayName
          tag
          description
          number
          displayNumber
          iconName
          isHighlighted
          type
          target
          resources {
            ...resourceFields
          }
          tags
          metadata
        }
      }
    }
  }
  ${resourceFieldsFragment}
`;

export const getCourseOutlineConfig = gql`
  query courseOutlineConfig($subjectId: String, $educationPeriod: String) {
    courseOutlineConfig(
      subjectId: $subjectId
      educationPeriod: $educationPeriod
    ) {
      subunitLabel
      ppcTagPair
      widgetTagColumn
      widgetTagColumnLabel
      curriculumCheckTabLabel
      unitsLabel
    }
  }
`;
